var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    opacity: 0.87
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    strokeWidth: 0.5,
    d: "M10.22 9.902v3.22H8.61c-.883 0-1.61.727-1.61 1.61V25.39c0 .883.727 1.61 1.61 1.61h15.024c.883 0 1.61-.727 1.61-1.61V14.732c0-.883-.727-1.61-1.61-1.61H11.293v-3.22a4.807 4.807 0 0 1 4.829-4.829 4.807 4.807 0 0 1 4.83 4.83v.536a.537.537 0 1 0 1.072 0v-.537A5.901 5.901 0 0 0 16.122 4a5.901 5.901 0 0 0-5.902 5.902zm13.414 4.293c.307 0 .537.23.537.537V25.39c0 .307-.23.537-.537.537H8.61a.524.524 0 0 1-.537-.537V14.732c0-.307.23-.537.537-.537h15.024z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M13.137 20.247l1.872 1.865 3.846-4.994"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.f67e49da6b0132cd65800a2116e495fc.svg";
export { ForwardRef as ReactComponent };